var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaychexFlexLogoLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 257.5 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#004b8d}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6 15.3h4c2.5 0 5.1.5 5.1 3.4 0 2.5-1.6 4.3-6.3 4.3H21l1.6-7.7zM5 43.6h11.6L19 32.1h7.9c10 0 16.5-6.6 16.5-14.3 0-8.4-4.5-12.3-11.5-12.3H13L5 43.6zM57.7 18.6 59.1 30h-7.3l5.9-11.4zm-25.1 25h12l2.9-5.4h12.4l.6 5.4H72L66.2 5.5H54.6l-22 38.1zM76.9 29.6 68.7 5.5h11.8l3.6 14.2 9.3-14.2h13.8l-18.6 24-2.9 14.1H74z",
    className: "st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M135.2 29.1c-.7 3.9-3.7 15.4-19.6 15.4-11.1 0-16.4-7.2-16.4-17.4 0-12.3 7.7-22.6 20.7-22.6 8.5 0 16.1 3.7 16.3 15.1h-11.1c.1-3.6-1.6-5.6-5.2-5.6-6.5 0-8.9 7.5-8.9 12.9 0 3.2.8 8 6.2 8 3.7 0 5.8-2.5 6.5-5.9l11.5.1zM142 5.5h11.8L151 18.7h10.7l2.8-13.2h11.8l-8 38.1h-11.7l3.1-15.1H149l-3.2 15.1h-11.7zM179.4 5.5h31.5l-2 9.8h-19.8l-1 4.7h18.4l-1.9 9.1h-18.4l-1 4.7h20.2l-2 9.8h-32z",
    className: "st0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m219 23.4-8.8-17.9H223l3.7 9.9 7.6-9.9h13.9l-15.9 17.9 9.3 20.2h-13.2L224.2 33l-8.9 10.6h-14.4zM249.7 7.2c0-1.4 1-2.5 2.4-2.5 1.3 0 2.4 1.1 2.4 2.5s-1 2.5-2.4 2.5c-1.3 0-2.4-1.1-2.4-2.5m-.5 0c0 1.7 1.3 2.9 2.9 2.9 1.6 0 2.9-1.2 2.9-2.9 0-1.6-1.3-2.9-2.9-2.9s-2.9 1.3-2.9 2.9m1.8 1.7h.5V7.5h.5l.9 1.5h.6l-1-1.5c.5 0 .9-.3.9-.9 0-.7-.4-1-1.2-1H251v3.3zm.5-2.9h.7c.4 0 .7.1.7.5 0 .5-.4.6-.9.6h-.5V6z",
    className: "st0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaychexFlexLogoLarge);
export default __webpack_public_path__ + "static/media/paychexFlexLogoLarge.6d3e6c6c58b3a39d6287c475b35dc9a6.svg";
export { ForwardRef as ReactComponent };